export default __webpack_public_path__ + "static/banner-ux-f5084c2789bfb5f4611b18fd4e53db15.jpg";